export const SUFFIX = {
  ONE: "one",
  FEW: "few",
  MANY: "many",
  OTHER: "other"
} as const;

// cs
const func1 = (value: number) => {
  if (value === 1) return SUFFIX.ONE;
  if (value === 2 || value === 3 || value === 4) return SUFFIX.FEW;
  return SUFFIX.OTHER;
};

// en, de, es, fi, it, nl, no, sv, tr, hu,
const func2 = (value: number) => {
  if (value === 1) return SUFFIX.ONE;
  return SUFFIX.OTHER;
};

// fr, pt
const func3 = (value: number) => {
  if (value === 0 || value === 1) return SUFFIX.ONE;
  return SUFFIX.OTHER;
};

// ja, id, ko
const func4 = () => {
  return SUFFIX.OTHER;
};

// pl
const func5 = (value: number) => {
  const lastDigit = Math.abs(value) % 10;

  if (value === 1) return SUFFIX.ONE;
  if (lastDigit === 2 || lastDigit === 3 || lastDigit === 4) return SUFFIX.FEW;
  return SUFFIX.MANY;
};

// ru, uk
const func6 = (value: number) => {
  const lastDigit = Math.abs(value) % 10;

  if (lastDigit === 1) return SUFFIX.ONE;
  if (lastDigit === 2 || lastDigit === 3 || lastDigit === 4) return SUFFIX.FEW;
  return SUFFIX.MANY;
};

// fil
const func7 = (value: number) => {
  const lastDigit = Math.abs(value) % 10;

  if (
    lastDigit === 0 ||
    lastDigit === 1 ||
    lastDigit === 2 ||
    lastDigit === 3 ||
    lastDigit === 5 ||
    lastDigit === 7 ||
    lastDigit === 8
  )
    return SUFFIX.ONE;
  return SUFFIX.OTHER;
};

// ro
const func8 = (value: number) => {
  if (value === 1) return SUFFIX.ONE;
  if (value <= 19) return SUFFIX.FEW;
  return SUFFIX.OTHER;
};

export const pluralSuffixes = {
  cs: func1,
  en: func2,
  de: func2,
  es: func2,
  fi: func2,
  fr: func3,
  it: func2,
  ja: func4,
  nl: func2,
  no: func2,
  pl: func5,
  "pt-BR": func3,
  ru: func6,
  sv: func2,
  tr: func2,
  fil: func7,
  hu: func2,
  id: func4,
  ko: func4,
  "ro-RO": func8,
  uk: func6
};
